import declareBidDocument from './mutations/declareBidDocument'
import declareTenderDocument from './mutations/declareTenderDocument'
import declareAwardDocument from './mutations/declareAwardDocument'
import declareContractDocument from './mutations/declareContractDocument'
import updateDocument from './mutations/updateDocument'
import deleteDocument from './mutations/deleteDocument'
import myDocuments from './queries/myDocuments'

export default {
  declareBidDocument,
  declareTenderDocument,
  declareAwardDocument,
  declareContractDocument,
  updateDocument,
  deleteDocument,
  myDocuments,
}
